import { Outlet, Navigate, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import LeftBar from "../components/LeftBar";
import { isTokenExpired, getValidToken, clearToken } from "../utils/auth";

interface Props {
  setSnackbar: any;
}

const PrivateRoutes: React.FC<Props> = ({ setSnackbar }) => {
  const navigate = useNavigate();
  const token = getValidToken();

  useEffect(() => {
    // Check token validity on mount and periodically
    const checkToken = () => {
      const currentToken = localStorage.getItem("token");
      if (!currentToken || isTokenExpired(currentToken)) {
        clearToken();
        setSnackbar({
          isOpen: true,
          message: "Your session has expired. Please login again.",
          type: "error",
        });
        navigate("/");
      }
    };

    // Check immediately
    checkToken();

    // Check every 5 minutes
    const interval = setInterval(checkToken, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [navigate, setSnackbar]);

  // If no valid token, redirect to login
  if (!token) {
    return <Navigate to="/" replace />;
  }

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <LeftBar setSnackbar={setSnackbar} />
      <Outlet />
    </div>
  );
};
export default PrivateRoutes;
